<h3>General Information</h3>

<div class="avatar-container" (click)="fileInputAvatar.click()">
  <input id="uploadAvatarInput" #fileInputAvatar type="file" accept=".png, .jpg, .jpeg" (change)="onAvatarImageSelected($event)">
  <div class="avatar">
    <lib-photo [url]="photoUrl" width="150px" height="150px" [radius]="'50%'"></lib-photo>
  </div>
</div>

<form [formGroup]="form" class="vertical-form">
  <div class="content">
    <mat-form-field>
      <mat-label>Advertiser name</mat-label>
      <input type="text" required matInput placeholder="" formControlName="name" maxlength="50">
      @if (!form.get('name')?.valid) {
        <mat-error>Please enter a valid name</mat-error>
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label>Description</mat-label>
      <input matInput placeholder="" formControlName="description" maxlength="100">
      @if (!form.get('description')?.valid) {
        <mat-error>Please enter a valid description</mat-error>
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label>App to redirect</mat-label>
      <input matInput placeholder="" formControlName="appToRedirect" maxlength="100">
      @if (!form.get('appToRedirect')?.valid) {
        <mat-error>Please enter a valid app to redirect</mat-error>
      }
    </mat-form-field>

    <app-multi-labels
      [isCountry]="true"
      searchKey="name"
      [labels]="filteredCountries"
      [availableLabelsQuery]="allCountries"
      [refreshAutocomplete]="refreshCountries"
      formControlName="countries"
      name="countries"
      [placeholder]="'Advertised Countries *'"
      (changed)="onCountriesChanged($event)">
    </app-multi-labels>

    <app-multi-labels
      searchKey="name"
      [labels]="filteredLanguages"
      [availableLabelsQuery]="allLanguages"
      [refreshAutocomplete]="refreshLanguages"
      formControlName="languages"
      name="languages"
      [placeholder]="'Languages'"
      (changed)="onLanguagesChanged($event)">
    </app-multi-labels>

    @if (availableLanguagesForPrimary.length > 0) {
      <mat-form-field>
        <mat-label>Primary Language</mat-label>
        <mat-select formControlName="primaryLanguage">
          @for (lang of availableLanguagesForPrimary; track lang.code) {
            <mat-option [value]="lang.code">{{ lang.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
  </div>

  <div class="form-actions">
    <lib-button type="button" variant="raised" color="primary" [disabled]="!form.valid" (buttonClick)="onSave()">Save</lib-button>
  </div>
</form>
